module.exports = __webpack_public_path__ + "img/exit.199e331f.svg";